export const Resources = {
    str: {
        OPERATION_FAILED: "Operationen misslyckades"
    }
}